import React from 'react'

//swiperItems should be an array of obj like it :
//[{title:'',value:''},..]

function SwipeBar({currentTab,swiperItems,onChangeTab}) {

  return (
    <div className="SwipeBar">
          {swiperItems.map((item,index) => (
            <div
              key={index}
              className={`swiper-item ${
                currentTab == item.value && "active"
              }`}
              onClick={() => {
                onChangeTab(item.value);
              }}
            >
            {item.title}
            </div>
          ))}
      </div>
  );
}


export default SwipeBar
